export default "__VITE_ASSET__Dou5x2KS__"